import { useCallback, useMemo, useState } from "react";

import { formatValorMonetario } from "@/screens/financeiro/obras/fichas/ficha-formatacao/ficha-formatacao";
import type { FichaCustosTableProps } from "./types-ficha-custos-table";

/**
 * Tabela "Escopo Macro da Obra": o tipo dominante abre expandido e a seta de cada tipo mostra ou
 * oculta os escopos macro dele. Material, Serviços e Total ainda não existem no banco: todos os
 * valores saem zerados até as histórias de custos entregarem a fonte dos dados.
 */
export function useFichaCustosTable({ tiposObra }: FichaCustosTableProps) {
  const [abertos, setAbertos] = useState<ReadonlySet<string>>(
    () => new Set(tiposObra.filter((tipo) => tipo.dominante).map((tipo) => tipo.id)),
  );

  const alternar = useCallback((tipoId: string) => {
    setAbertos((atual) => {
      const proximo = new Set(atual);
      if (!proximo.delete(tipoId)) proximo.add(tipoId);
      return proximo;
    });
  }, []);

  const linhas = useMemo(
    () =>
      tiposObra.map((tipo) => {
        const aberto = abertos.has(tipo.id);
        return {
          ...tipo,
          aberto,
          rotuloToggle: `${aberto ? "Recolher" : "Expandir"} ${tipo.codigo} ${tipo.nome}`,
          icone: aberto ? "pi pi-chevron-down" : "pi pi-chevron-right",
          testIds: {
            linha: `ficha-custos-tipo-${tipo.id}`,
            toggle: `ficha-custos-toggle-${tipo.id}`,
            vazio: `ficha-custos-vazio-${tipo.id}`,
          },
          escoposMacro: tipo.escoposMacro.map((escopo) => ({
            ...escopo,
            testId: `ficha-custos-escopo-${escopo.id}`,
          })),
        };
      }),
    [tiposObra, abertos],
  );

  return { linhas, alternar, valorZero: formatValorMonetario(0) };
}
